// src/pages/IncomeReportPage.jsx
import React, { useState } from "react";
import { useLazyGetIncomeReportQuery } from "../../../redux/api/salary";
import { useSelector } from "react-redux";
import { selectCurrentagency } from "../../../redux/features/authSlice";

import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  Stack,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import BackButton from "../../../components/BackButton/BackButton";

const IncomeReportPage = () => {
  const currentAgency = useSelector(selectCurrentagency);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [getIncomeReport, { data, isFetching }] =
    useLazyGetIncomeReportQuery();

  const handleFetchReport = () => {
    if (!currentAgency.agencyid || !fromDate || !toDate) {
      return alert("Please fill all fields");
    }
    getIncomeReport({
      agencyId: currentAgency.agencyid,
      fromDate: dayjs(fromDate).format("YYYY-MM-DD"),
      toDate: dayjs(toDate).format("YYYY-MM-DD"),
    });
  };

  return (
    <Box p={4}>
     <Box sx={{ mb: 3 }}>
      <Stack  alignItems="start" spacing={2}>
        <BackButton />
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Income Report
        </Typography>
      </Stack>
    </Box>

      {/* Filters */}
      <Paper sx={{ p: 3, mb: 4 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={(newValue) => setFromDate(newValue)}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    variant: "outlined",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <DatePicker
                label="To Date"
                value={toDate}
                onChange={(newValue) => setToDate(newValue)}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                    variant: "outlined",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                onClick={handleFetchReport}
                variant="contained"
                disabled={isFetching}
                sx={{ color: "white" }}
              >
                {isFetching ? <CircularProgress size={24} /> : "Get Report"}
              </Button>
            </Grid>
          </Grid>
        </LocalizationProvider>
      </Paper>

      {/* Report Result */}
      {data && (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <Card sx={{ bgcolor: "primary.main", color: "white" }}>
              <CardContent>
                <Typography variant="subtitle1">Total Balance</Typography>
                <Typography variant="h5" fontWeight="bold">
                  {data.totalBalance}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card sx={{ bgcolor: "secondary.main", color: "white" }}>
              <CardContent>
                <Typography variant="subtitle1">Total Advance</Typography>
                <Typography variant="h5" fontWeight="bold">
                  {data.totalAdvance}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card sx={{ bgcolor: "error.main", color: "white" }}>
              <CardContent>
                <Typography variant="subtitle1">Total Expenses</Typography>
                <Typography variant="h5" fontWeight="bold">
                  {data.totalexpanses}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card sx={{ bgcolor: "success.main", color: "white" }}>
              <CardContent>
                <Typography variant="subtitle1">Installment Paid</Typography>
                <Typography variant="h5" fontWeight="bold">
                  {data.totalinstallmentpaid}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Card sx={{ bgcolor: "warning.main", color: "white" }}>
              <CardContent>
                <Typography variant="subtitle1">
                  Installment Not Paid
                </Typography>
                <Typography variant="h5" fontWeight="bold">
                  {data.totalinstallmentnotpaid}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default IncomeReportPage;
